const modalSupportTextField = {
  label: 'Descripción'
};

export default modalSupportTextField;
